<template>
  <v-carousel
    class="carousel"
    interval="5000"
    height="auto"
    :hide-delimiters="items.length === 1"
    :show-arrows="items.length > 1"
    :cycle="items.length > 1"
    hide-delimiter-background
    show-arrows-on-hover
    cycle
    light
  >
    <v-carousel-item
      v-for="item in items"
      :key="item.id"
      :src="item.banner_url"
      class="carousel__item"
      @click="openUrl(item)"
    >
      <div v-if="item.link" class="carousel__content">
        <v-btn
          v-if="IsRemoteUrl(item.link)"
          class="carousel__content-btn"
          @click="openUrl(item)"
        >Подробнее</v-btn>
        <v-btn
          v-else
          class="carousel__content-btn"
          :to="item.link"
        >Подробнее</v-btn>
      </div>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
  export default {
    props: ['items'],
    methods: {
      openUrl(item) {
        console.log(item);
        window.open(item.link, item.target);
      },
      IsRemoteUrl(url) {
        return (url.indexOf('://') !== -1);
      },
    },
  };
</script>

<style lang="scss">
  @import '../../assets/scss/variables';

  .carousel {
    background: $carousel-bg-color;
    padding-bottom: 50px;
    .v-image__image--cover {
      background-size: contain;

      @media all and (min-width: 1260px){
        background-size: cover;
      }
    }
    &__content {
      display: flex;
      height: 100%;
      justify-content: center;
      align-items: flex-end;
      padding-bottom: 10px;
      @media all and (max-width: 960px){
        display: none;
      }
    }
  }
</style>
